import React, { useEffect, useState } from "react";
import { Form, Input, Button, Col, Row, Select, Divider, Typography } from "antd";
import { PlusOutlined, MinusCircleOutlined } from "@ant-design/icons";
import inputStyles from "../../../styles/Custom/Input.module.css";
import { payerOptions } from "../receptionKeys";
import { getPartnerListApi } from "../../../services/partner.services";
import { getCookie } from "../../../helpers/localStorage";
import { FacilityID } from "../../../constants/defaultKeys";

const PayerDetails = () => {
  const [consultantOptions, setConsultantOptions] = useState([]);
  const facilityId = Number(getCookie(FacilityID)) || null;

  useEffect(() => {
    if (facilityId) {
      getPartnerListApi()
        .then((res) => {
          const fetchedPartners = res?.data?.data || [];
          const uniquePartners = fetchedPartners.reduce((acc, item) => {
            if (!acc.some((p) => p.id === item.id)) {
              acc.push(item);
            }
            return acc;
          }, []);

          setConsultantOptions(
            uniquePartners.map((item) => ({
              label: `${(item?.first_name || "").trim()} ${(
                item?.last_name || ""
              ).trim()}`,
              value: item?.id,
            }))
          );
        })
        .catch((err) => console.error("Error fetching partners:", err));
    }
  }, [facilityId]);

  return (
    <>
      <Col xs={24} md={8}>
        <Form.Item label="Payer" name="payer">
          <Select
            allowClear
            placeholder="Payer"
            className={inputStyles.mdSelect}
            options={payerOptions}
          />
        </Form.Item>
      </Col>

      <Col xs={24} md={8}>
        <Form.Item
          label="Insurance Corporate Name"
          name="insurance_corporate_name"
        >
          <Input
            placeholder="Insurance Corporate Name"
            className={inputStyles.mdInput}
          />
        </Form.Item>
      </Col>

      <Col xs={24} md={8}>
        <Form.Item label="Insurance Corporate ID" name="insurance_corporate_id">
          <Input
            placeholder="Insurance Corporate ID"
            className={inputStyles.mdInput}
          />
        </Form.Item>
      </Col>

      <Col span={24}>
        <Form.Item label="Notes" name="message">
          <Input.TextArea
            placeholder="Notes"
            className={inputStyles.mdInput}
            rows={3}
          />
        </Form.Item>
      </Col>

      <Col span={24}>
        <Divider className="inpatient-drawer-divider" />
        <Typography.Text strong className="inpatient-drawer-section-title">
          Primary Consultant
        </Typography.Text>
      </Col>

      <Col span={24}>
        <Form.List
          name="primary_consultant_details"
          initialValue={[
            {
              primary_consultant_name: "",
              primary_consultant_designation: "",
              primary_consultant_hospital: "",
            },
          ]}
        >
          {(fields, { add, remove }) => (
            <>
              {fields.map(({ key, name, ...restField }) => (
                <Row gutter={16} key={key} className="inpatient-consultant-row">
                  <Col xs={24} md={8}>
                    <Form.Item
                      {...restField}
                      name={[name, "primary_consultant_name"]}
                    >
                      <Input
                        placeholder="Primary Consultant Name"
                        className={inputStyles.mdInput}
                      />
                    </Form.Item>
                  </Col>
                  <Col xs={24} md={8}>
                    <Form.Item
                      {...restField}
                      name={[name, "primary_consultant_designation"]}
                    >
                      <Input
                        placeholder="Primary Consultant Designation"
                        className={inputStyles.mdInput}
                      />
                    </Form.Item>
                  </Col>
                  <Col xs={24} md={7}>
                    <Form.Item
                      {...restField}
                      name={[name, "primary_consultant_hospital"]}
                    >
                      <Input
                        placeholder="Primary Consultant Hospital"
                        className={inputStyles.mdInput}
                      />
                    </Form.Item>
                  </Col>
                  {fields.length > 1 && (
                    <Col
                      xs={24}
                      md={1}
                      className="inpatient-consultant-remove"
                    >
                      <MinusCircleOutlined onClick={() => remove(name)} />
                    </Col>
                  )}
                </Row>
              ))}
              <Form.Item className="inpatient-add-consultant-item">
                <Button
                  type="dashed"
                  onClick={() => add()}
                  block
                  icon={<PlusOutlined />}
                  className="inpatient-add-consultant-btn"
                >
                  Add Consultant
                </Button>
              </Form.Item>
            </>
          )}
        </Form.List>
      </Col>

      <Col span={24}>
        <Typography.Text strong className="inpatient-drawer-section-title">
          Partners
        </Typography.Text>
        <Form.Item name="primary_consultants" className="inpatient-partners-field">
          <Select
            mode="multiple"
            allowClear
            placeholder="Select Partners"
            className={inputStyles.mdSelect}
            options={consultantOptions}
            filterOption={(input, option) =>
              option.label.toLowerCase().includes(input.toLowerCase())
            }
          />
        </Form.Item>
      </Col>
    </>
  );
};

export default PayerDetails;
